import { Link } from 'react-router-dom';
import { CONSOLE_LINK, FOOTER_GROUPS, FOOTER_INLINE } from '@/content/nav';
import { BRAND } from '@/content/site';
import { Icon } from './Icon';
import { Wordmark } from '@/illustrations/Mark';

function currentYear(): number {
  return Math.max(new Date().getFullYear(), BRAND.copyrightFrom);
}

/**
 * 页脚。分五列：产品 / 解决方案 / 资源与支持 / 公司 / 法务。
 * 商标与「不销售整机」的表述集中在这里，全站只出现一次。
 */
export function Footer() {
  const year = currentYear();
  const linkClass = 'text-sm text-fg-muted transition-colors hover:text-brand';

  return (
    <footer className="border-t border-line bg-surface-1">
      <div className="container-page py-14">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-10 md:grid-cols-3 lg:grid-cols-[minmax(0,1.6fr)_repeat(5,minmax(0,1fr))]">
          <div className="flex flex-col gap-4">
            <Wordmark />
            <p className="max-w-xs text-sm leading-relaxed text-fg-muted">
              面向机队运营的监管软件，为低空经济提供稳固基础。
            </p>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="inline-flex items-center gap-2 text-fg-muted transition-colors hover:text-brand"
                >
                  <Icon name="mail" size={15} />
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-fg-muted transition-colors hover:text-brand"
                >
                  <Icon name="code" size={15} />
                  {BRAND.githubLabel}
                </a>
              </li>
            </ul>
          </div>

          {FOOTER_GROUPS.map((group) => (
            <div key={group.title} className="flex flex-col gap-3">
              <h2 className="text-sm font-semibold text-fg">{group.title}</h2>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.to}-${link.label}`}>
                    {link.external ? (
                      <a href={link.to} target="_blank" rel="noopener noreferrer" className={linkClass}>
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.to} className={linkClass}>
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <nav
          aria-label="页脚快捷导航"
          className="mt-12 flex flex-wrap gap-x-5 gap-y-2 border-t border-line pt-6 lg:hidden"
        >
          {FOOTER_INLINE.map((link) => (
            <Link key={link.to} to={link.to} className={linkClass}>
              {link.label}
            </Link>
          ))}
          <a href={CONSOLE_LINK.to} target="_blank" rel="noopener noreferrer" className={linkClass}>
            {CONSOLE_LINK.label}
          </a>
        </nav>

        <div className="mt-12 flex flex-col gap-4 border-t border-line pt-6 text-xs leading-relaxed text-fg-muted lg:mt-6">
          <p>
            Havorix™ 商标注册申请中。本站不销售无人机整机，亦不提供整机购买渠道；平台提供的是监管软件、接入与部署服务。
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>
              © {BRAND.copyrightFrom}–{year} Havorix
            </span>
            <Link to="/privacy" className="transition-colors hover:text-brand">
              隐私政策
            </Link>
            <Link to="/terms" className="transition-colors hover:text-brand">
              使用条款
            </Link>
            <span className="text-fg-subtle">本站不采集访问数据，也没有第三方统计。</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
